import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DocumentData } from 'firebase/firestore';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import useLocales from 'hooks/useLocales';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
    textAlign: 'center',
    height: '100%',
    [theme.breakpoints.up('md')]: {
        display: 'flex',
        textAlign: 'left',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
}));

// ----------------------------------------------------------------------

interface TopicCardProps {
    lesson: DocumentData;
    order: number;
}

const LessonCard: React.FunctionComponent<TopicCardProps> = ({ lesson, order }) => {
    const { translate } = useLocales();
    return (
        <RootStyle>
            <CardContent
                sx={{
                    p: { md: 3 },
                    pl: { md: 5 },
                    color: 'grey.800',
                    width: '100%',
                }}
            >
                <Box
                    sx={{
                        display: { md: 'flex' },
                        alignItems: { md: 'center' },
                        justifyContent: { md: 'space-between' },
                    }}
                >
                    <Box>
                        <Typography variant='subtitle2'>
                            {translate('lesson')} {order}
                        </Typography>
                        <Typography gutterBottom variant='h4'>
                            {lesson.title}
                        </Typography>
                    </Box>

                    <Button
                        variant='contained'
                        to={lesson.id}
                        component={RouterLink}
                        sx={{ width: { xs: '100%', md: 'inherit' } }}
                    >
                        {translate('view_lesson')}
                    </Button>
                </Box>
            </CardContent>
        </RootStyle>
    );
};

export default LessonCard;
